import React from 'react'
import './Navigator.scss'

const Element = ({ slug, url, alt }) => {
  return (
    <img id={slug} src={url} alt={alt} className='img-element' />
  )
}

export default Element